import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { provideApplicationInsights, provideFullstory } from '../../../domain/src/public-api';
import { BASE_PATH } from 'sdk/stactize-signup-bff-sdk';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideApplicationInsights(environment.applicationInsights.connectionString),
    { provide: BASE_PATH, useValue: '.' }, //Base Path for SDK is root
    provideFullstory({
      orgId: environment.fullstory.orgId,
      devMode: !environment.fullstory.isEnabled
    })
  ]
};
